import React,{useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import MoneyPickedStepper from "./MoneyPickedStepper";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    // marginBottom: "40px",
  },

  marginBottomStyle: {
    marginBottom: "40px",
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  paddingStyle: {
    padding: "160px",
  },
  centerAlign: {
    textAlign: "center",
  },
  rightAlign: {
    textAlign: "right",
  },
  titleStyle: {
    fontWeight: 600,
  },
}));

const MoneyPicked = () => {
  const classes = useStyles();
  const [title, setTitle] = useState("");
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={8}>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        <Grid item xs={4} className={`${classes.rightAlign}`}>
          {/* <Typography
            variant="body1"
            color="primary"
            className={classes.titleStyle}
          >
            CHANGE
          </Typography> */}
        </Grid>
        <Grid item xs={12}>
          <Divider style={{ marginTop: "15px" }} />
        </Grid>
        <Grid item xs={12}>
          <MoneyPickedStepper setTitle={setTitle}/>
        </Grid>
      </Grid>
    </div>
  );
};

export default MoneyPicked;
